import * as React from "react";

const FreeAdvertisementIcon = (props) => (
	<svg
		width={24}
		height={16}
		viewBox="0 0 24 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12 12V6M12 6L9 8M12 6L15 8M23 11C23 8.79086 21.2091 7 19 7C18.9764 7 18.9532 7.00021 18.9297 7.00062C18.4447 3.60802 15.5267 1 12 1C9.20335 1 6.79019 2.64004 5.66895 5.01082C3.06206 5.18144 1 7.34981 1 9.99985C1 12.7613 3.23858 15.0001 6 15.0001L19 15C21.2091 15 23 13.2091 23 11Z"
			stroke="white"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default FreeAdvertisementIcon;
